module.exports = __webpack_public_path__ + "static/media/cuisine.2ebccf7f.jpg";